import { TrueBase, css, html } from "../TrueBase/TrueBase";

/**
 * @customelement - true-flex-block
 * @description
 * A flex block used for aligning child items
 *
 * ### Properties
 *
 *
 */
export class TrueFlexBlock extends TrueBase {
  static get properties() {
    return {
      justifyContent: {
        type: String,
        reflect: true,
      },
      alignItems: {
        type: String,
        reflect: true,
      },
      flexDirection: {
        type: String,
      },
      directionOnMobile: {
        type: String,
      },
    };
  }

  constructor() {
    super();
  }

  render() {
    return html` <slot></slot> `;
  }

  static get styles() {
    return css`
      :host {
        display: flex;
      }

      :host([justifyContent="start"]) {
        justify-content: flex-start;
      }

      :host([justifyContent="center"]) {
        justify-content: center;
      }

      :host([justifyContent="end"]) {
        justify-content: flex-end;
      }

      :host([justifyContent="space-between"]) {
        justify-content: space-between;
      }

      :host([justifyContent="space-evenly"]) {
        justify-content: space-evenly;
      }

      :host([justifyContent="space-around"]) {
        justify-content: space-around;
      }

      :host([alignItems="start"]) {
        align-items: flex-start;
      }

      :host([alignItems="end"]) {
        align-items: flex-end;
      }

      :host([alignItems="center"]) {
        align-items: center;
      }

      :host([alignItems="stretch"]) {
        align-items: stretch;
      }

      :host([flexDirection="column"]) {
        flex-direction: column;
      }

      :host([flexDirection="row"]) {
        flex-direction: row;
      }

      @media screen and (max-width: 768px) {
        :host([directionOnMobile="column"]) {
          flex-direction: column;
        }

        :host([directionOnMobile="column-reverse"]) {
          flex-direction: column-reverse;
        }

        :host([directionOnMobile="row-reverse"]) {
          flex-direction: row-reverse;
        }

        :host([directionOnMobile="row"]) {
          flex-direction: row;
        }
      }
    `;
  }
}

window.customElements.get("true-flex-block") ||
  window.customElements.define("true-flex-block", TrueFlexBlock);
